export const generateDuplicateName = (baseName: string, existingNames: string[]) => {
  let newName = baseName
  let count = 1

  // Kiểm tra xem tên base đã là -copy-X chưa
  const match = baseName.match(/-copy-(\d+)$/)
  if (match) {
    count = parseInt(match[1], 10) + 1
    newName = `${baseName.replace(/-copy-(\d+)$/, "")}-copy-${count}`
  } else {
    newName = `${baseName}-copy-1`
  }

  // Tăng số nếu đã tồn tại trong existingNames
  while (existingNames.includes(newName)) {
    count++
    newName = `${baseName.replace(/-copy-\d*$/, "")}-copy-${count}`
  }

  return newName
}
